/**
 * Het beheerpaneel: acht tabbladen, elk in een eigen bestand in tabs/.
 *
 *   Teksten        de standaardteksten maken en bewerken
 *   Niveauteksten  elke tekst op elk niveau laten maken, bewerken en goedkeuren (stap 18)
 *   Tekstlengte    hoeveel woorden een tekst op elk niveau heeft
 *   Illustraties   per tekst een plaatje in drie stijlen
 *   Leerkrachten   accounts voor de leerkrachten
 *   Prompts        de prompts voor het taalmodel
 *   LLM Config     model, beelddienst, voorleesstem en sleutels
 *   Spraakproef    wat Voxtral hoort in een ingesproken zin met een gat (stap 28)
 *
 * Een tabblad dat eenmaal open is geweest, blijft bestaan als je naar een
 * ander gaat (het wordt alleen verborgen). Zo raak je een half ingevoerde
 * tekst of prompt niet kwijt door even een ander tabblad te bekijken. Bij
 * elke keer openen haalt het tabblad zijn gegevens opnieuw op.
 *
 * Een fout van de server staat boven alle tabbladen; elk tabblad meldt hem
 * via `meldFout`. Hij hoort bij het tabblad waar hij ontstond: ga je naar
 * een ander tabblad, dan verdwijnt hij. Met het kruisje klik je hem weg.
 */
import React, { useState } from 'react';
import { FileText, Image, Layers, MessageSquare, Mic, Ruler, Settings, Users, X } from 'lucide-react';
import { Kop } from '../../components/Kop';
import { Illustraties } from './tabs/Illustraties';
import { Leerkrachten } from './tabs/Leerkrachten';
import { Niveauteksten } from './tabs/Niveauteksten';
import { Prompts } from './tabs/Prompts';
import { Spraakproef } from './tabs/Spraakproef';
import { Taalmodel } from './tabs/Taalmodel';
import { Teksten } from './tabs/Teksten';
import { Tekstlengte } from './tabs/Tekstlengte';

const TABS = [
  { id: 'teksten', label: 'Teksten', icon: FileText, Tab: Teksten },
  { id: 'niveauteksten', label: 'Niveauteksten', icon: Layers, Tab: Niveauteksten },
  { id: 'tekstlengte', label: 'Tekstlengte', icon: Ruler, Tab: Tekstlengte },
  { id: 'illustraties', label: 'Illustraties', icon: Image, Tab: Illustraties },
  { id: 'leerkrachten', label: 'Leerkrachten', icon: Users, Tab: Leerkrachten },
  { id: 'prompts', label: 'Prompts', icon: MessageSquare, Tab: Prompts },
  { id: 'llm', label: 'LLM Config', icon: Settings, Tab: Taalmodel },
  { id: 'spraakproef', label: 'Spraakproef', icon: Mic, Tab: Spraakproef },
];

function BeheerPaneel({ onLogout }) {
  const [actief, setActief] = useState('teksten');
  const [geopend, setGeopend] = useState(['teksten']);
  const [fout, setFout] = useState('');

  const kies = (id) => {
    if (id !== actief) setFout('');
    setActief(id);
    setGeopend(prev => (prev.includes(id) ? prev : [...prev, id]));
  };

  return (
    <div>
      <Kop naam="Admin" onLogout={onLogout} tabs={TABS} actief={actief} kiesTab={kies} />
      <div className="container">
        {fout && (
          <div className="alert alert-error" role="alert" style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
            <span style={{ flex: 1 }}>{fout}</span>
            <button type="button" onClick={() => setFout('')} aria-label="Melding sluiten" title="Melding sluiten"
              style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: 'inherit', lineHeight: 0 }}>
              <X size={16} />
            </button>
          </div>
        )}
        {TABS.filter(t => geopend.includes(t.id)).map(({ id, Tab }) => (
          <div key={id} hidden={actief !== id}>
            <Tab actief={actief === id} meldFout={setFout} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default BeheerPaneel;
